export default __webpack_public_path__ + "static/media/no1.2dff3731.png";